<div class="h-100 bg-primary d-flex align-items-center justify-content-center">
  <div class="text-white">
    <h1 class="display-1 text-center">404</h1>
    <h2 class="text-center">Not Found</h2>
    <p class="text-center">The resource requested could not be found.</p>
    <p class="text-center">
      <a href="/">Go to Dashboard</a>
    </p>
  </div>
</div>